export default __webpack_public_path__ + "static/media/meat.111f30aa.jpg";